import { Paths, PathValue } from "@mctypes/global.types";
import React from "react";
import { Button, Paper, Stack, Title } from "@mantine/core";
import { HSpace, McInputNew, McTextAreaNew } from "../../../../../../../components";
import {
  IGKLufthastighetskontrollResultater,
  IGKRapport,
} from "@mcapps/shared/reportSchemas/gkReportSchema";
import ReportDocxImageContainer from "../../../../ReportBoard/ReportDocxImageContainer";
import Luftventil from "../Luftventil";
const Lufthastighetskontroll: React.FC<{
  onUpdateEditData: <P extends Paths<IGKRapport, 4>>(path: P, value: PathValue<IGKRapport, P>) => void;
  data: IGKLufthastighetskontrollResultater;
}> = ({ data, onUpdateEditData }) => {
  const addNewRow = () => {
    const newMaaleresultaterArray = {
      ventilnummer: null,
      maaleomraadeAreal: null,
      maaleresultater: [],
      beregninger: {
        minimumAntallRuterIRutenett: null,
        gjennomsnittligHastighet: null,
        varians: null,
        standardAvvik: null,
        lufthastighetUniformitet: null,
      },
    };
    const updatedMaaleresultaterArray = [...data.inndata.resultaterPerVentil, newMaaleresultaterArray];
    onUpdateEditData("testResultater.lufthastighetskontroll.inndata.resultaterPerVentil", updatedMaaleresultaterArray);
    return updatedMaaleresultaterArray;
  };
  const removeLastRow = () => {
    const updatedMaaleresultaterArray = [...data.inndata.resultaterPerVentil];
    if (updatedMaaleresultaterArray.length > 0) {
      updatedMaaleresultaterArray.pop(); // Remove the last element
      onUpdateEditData(
        "testResultater.lufthastighetskontroll.inndata.resultaterPerVentil",
        updatedMaaleresultaterArray,
      );
    }
  };
  const onUpdateVentilData = (updatedData: any, ventilIndex: number) => {
    const resultaterPerVentil = [...data.inndata.resultaterPerVentil];
    resultaterPerVentil[ventilIndex] = updatedData;
    onUpdateEditData("testResultater.lufthastighetskontroll.inndata.resultaterPerVentil", resultaterPerVentil);
  };
  return (
    <Paper withBorder p="sm" radius="sm" bg="#fdfdff">
      <Stack gap="xs">
        <Title order={4} fw={400}>Lufthastighetskontroll</Title>
        <div className="d-flex flex-column mb-4">
          <b>Legg til og trekk fra ventiler:</b>
          <div className="d-flex">
            <Button color="green" onClick={addNewRow}>
              Legg til ventil
            </Button>
            <HSpace />
            <Button
              variant="danger-filled"
              onClick={removeLastRow}
              disabled={data.inndata?.resultaterPerVentil?.length < 1}
            >
              Fjern siste ventil
            </Button>
          </div>
        </div>
        {data.inndata.resultaterPerVentil != null && data.inndata.resultaterPerVentil?.length > 0 && (
          <>
            {data.inndata.resultaterPerVentil.map((resultat, index) => (
              <div className="mb-4" key={index}>
                <b>Luftventil {index + 1}</b>
                <Luftventil onUpdateVentilData={onUpdateVentilData} data={resultat} ventilIndex={index} />
              </div>
            ))}
          </>
        )}
        <div className="w-50 mt-4">
          <div>
            <ReportDocxImageContainer docxImageTag="lufthastighetskontroll" title="Målepunkter i rommet" />
          </div>
          <McTextAreaNew
            label="Kommentar:"
            value={data.inndata.kommentar}
            onChange={(e) =>
              onUpdateEditData("testResultater.lufthastighetskontroll.inndata.kommentar", e.target.value)
            }
          />
        </div>
      </Stack>
    </Paper>
  );
};
export default Lufthastighetskontroll;